module.exports = __webpack_public_path__ + "img/34_24.f3a429d7.png";